//@flow
import * as React from 'react';
import { Icon, defaultTheme } from '@locus-taxy/neo-ui';

type IconProps = React.ElementConfig<typeof Icon>;

type IconPropsWithGradient = {
    ...IconProps,
    gradient?: string
};

const { grey } = defaultTheme.colors;

export const Gradients = Object.freeze({
    GREY_STRIPES: `repeating-linear-gradient(45deg, ${grey[400]}, ${grey[400]} 2px, ${grey[700]} 0, ${grey[700]} 5px)`
});

export const IconWithGradient = (props: IconPropsWithGradient): React.Node => {
    const { gradient, sx, ...others } = props;
    const gradientStyles = gradient
        ? {
              '&:before': {
                  background: gradient,
                  backgroundClip: 'text',
                  '-webkit-background-clip': 'text',
                  color: 'transparent',
                  position: 'relative'
              }
          }
        : null;
    return <Icon {...others} sx={{ ...sx, ...gradientStyles }} />;
};
